export const ONNX_CROP_PROCESS_KEY = 'ai.classify-crops-onnx';

const inferenceUrl = /^local:\/\/onnx-crop-classification\/([0-9a-f-]{36})$/i;
const artifactLog = /ONNX artifact model=([^,\s]+)/;

export interface OnnxAssignmentModel {
  id: string | null;
  code: string | null;
  name: string | null;
  version: string | null;
  fileName: string | null;
  url: string | null;
}

export function readOnnxAssignmentModel(
  processKey: string | null | undefined,
  safeOutputJson: string | null | undefined,
  callUrls: readonly (string | null | undefined)[],
  logLines: readonly string[],
): OnnxAssignmentModel | null {
  if (processKey?.trim() !== ONNX_CROP_PROCESS_KEY) {
    return null;
  }

  const output = readObject(safeOutputJson);
  const fromUrl = callUrls.map(url => inferenceUrl.exec(url?.trim() ?? '')?.[1] ?? null).find(id => !!id) ?? null;
  const fromLog = logLines.map(line => artifactLog.exec(line)?.[1] ?? null).find(code => !!code) ?? null;
  const id = text(output, 'modelId', 'ModelId') ?? fromUrl;
  const code = text(output, 'modelCode', 'ModelCode') ?? fromLog;
  if (!id && !code) {
    return {
      id: null,
      code: null,
      name: null,
      version: null,
      fileName: null,
      url: null,
    };
  }

  return {
    id,
    code,
    name: text(output, 'modelName', 'ModelName'),
    version: text(output, 'modelVersion', 'ModelVersion'),
    fileName: text(output, 'onnxFileName', 'OnnxFileName'),
    url: id ? `/admin/ai-modules/OnnxCropClassification/models/${id}` : null,
  };
}

function readObject(json: string | null | undefined): Record<string, unknown> | null {
  if (!json?.trim()) {
    return null;
  }
  try {
    const parsed = JSON.parse(json) as unknown;
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? parsed as Record<string, unknown>
      : null;
  } catch {
    return null;
  }
}

function text(source: Record<string, unknown> | null, ...keys: string[]): string | null {
  for (const key of keys) {
    const value = source?.[key];
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }
  return null;
}
